import Vue from 'vue';
import LiveBlog from './LiveBlog.vue';

Vue.config.productionTip = false;

var elements = document.querySelectorAll('.joomla-script-options');
if (elements.length > 0) {
  var options = JSON.parse(elements[0].text || elements[0].textContent);
  options.modules.forEach((module) => {
    if (module.name === 'LiveBlog') {
      new Vue({
        el: module.options.selector,
        render: function(createElement) {
          return createElement(LiveBlog, {
            props: {
              options: module.options
            }
          });
        }
      });
    }
  });
}
